import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

// material-ui components
import withStyles from '@material-ui/core/styles/withStyles';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';

import Card from 'components/Cards/Card';
import loginCardStyle from 'components/Cards/style/loginCardStyle';

function LoginCard(props) {
  const { classes, headerColor, plainCard, cardTitle, cardSubtitle, content, footer, socials, customCardClass } = props;
  const plainCardClasses = cx({
    [` ${classes.cardPlain}`]: plainCard,
    [` ${customCardClass}`]: customCardClass !== undefined,
  });
  const cardPlainHeaderClasses = cx({
    [` ${classes.cardPlainHeader}`]: plainCard,
  });
  return (
    <Card className={classes.card + plainCardClasses}>
      <CardHeader
        classes={{
          root: `${classes.cardHeader} ${classes[`${headerColor}CardHeader`]}${cardPlainHeaderClasses}`,
          title: classes.cardTitle,
          subheader: classes.cardSubtitle,
        }}
        title={cardTitle}
        subheader={socials}
      />
      <div className={classes.cardSubtitle}>{cardSubtitle}</div>
      <CardContent className={classes.cardContent}>{content}</CardContent>
      <div className={classes.cardFooter}>{footer}</div>
    </Card>
  );
}

LoginCard.defaultProps = {
  headerColor: 'purple',
};

LoginCard.propTypes = {
  plainCard: PropTypes.bool,
  classes: PropTypes.object.isRequired,
  headerColor: PropTypes.oneOf(['orange', 'green', 'red', 'blue', 'purple', 'rose', 'primary', 'white']),
  cardTitle: PropTypes.node,
  cardSubtitle: PropTypes.node,
  content: PropTypes.node,
  footer: PropTypes.node,
  socials: PropTypes.node,
  footerAlign: PropTypes.oneOf(['left', 'right', 'center']),
  customCardClass: PropTypes.string,
};

export default withStyles(loginCardStyle)(LoginCard);
